module.exports = __webpack_public_path__ + "static/media/_dropdown-menu-right.033cfa8e.scss";


//////////////////
// WEBPACK FOOTER
// ./src/scss/core/_dropdown-menu-right.scss
// module id = 688
// module chunks = 0